export default "__VITE_ASSET__AXEyYQmZ__"